import { Navigate, Outlet } from "react-router-dom";
import { useAuthStore } from "../store/auth";
import React from "react";

export const PrivateRouterOutlet = () => {
  const { user } = useAuthStore();

  return user ? <Outlet /> : <Navigate to="/error" />;
};
